import { render } from "./index.vue?vue&type=template&id=3ed04e44&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3ed04e44&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed04e44"]])

export default __exports__